module.exports = __webpack_public_path__ + "img/jam02.cf2f8844.jpg";